/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ username: NonNullable<unknown> }} East_Even_Bison_FallInputs */

const fr_east_even_bison_fall = /** @type {(inputs: East_Even_Bison_FallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Supprimer utilisateur ${i?.username}`)
};

/**

* @param {East_Even_Bison_FallInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const east_even_bison_fall = /** @type {((inputs: East_Even_Bison_FallInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<East_Even_Bison_FallInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_east_even_bison_fall(inputs)
});